module.exports = __webpack_public_path__ + "static/img/kejiguan.9e07a38.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/kejiguan.png
// module id = l+7k
// module chunks = 1